import axios from 'axios'

class AdminService {
  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  getClients (searchText, enabled) {
    let url = `${process.env.API}/clients`
    return axios.get(url)
  }
}

const admin = new AdminService()

export default admin
export { admin }



// WEBPACK FOOTER //
// ./src/services/admin.service.js